module.exports = __webpack_public_path__ + "static/img/icon_94_jinghuano.405f1cc6.png";